import util from '../util'

let controller = 'v1/recuperacoes-valores'

export default Object.assign({}, util.GetCrud(controller, null), {
  InserirParametrizacao: function (dto) {
    return util.Axios.Post(controller + '/parametrizacao', dto)
  },
  AtualizarParametrizacao(dto) {
    return util.Axios.Put(controller + '/parametrizacao', dto.codigo, dto)
  },
  ListarParametrizacao: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/parametrizacao', dto)
  },
  ListarRecuperacaoValoresTransacoes(dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/transacoes', dto)
  },
  CancelarRecuperacaoValores: function (dto, id) {
    return util.Axios.Post(controller + `/${id}/cancelar`, dto)
  },
  DetalhesRecuperacaoValores: function (id) {
    return util.Axios.Get(controller, id)
  },
  SolicitarRecuperacaoValores(dto) {
    return util.Axios.Post(controller, dto)
  },
  ListarRecuperacaoValores(dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  }
})
